import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const getAuthHeaders = () => {
  const token = localStorage.getItem('token') || sessionStorage.getItem('token');
  return { headers: { Authorization: `Bearer ${token}` } };
};

export const fetchUsers = createAsyncThunk('adminUsers/fetchUsers', async (_, { rejectWithValue }) => {
  try {
    const res = await axios.get('http://localhost:5000/api/admin/users', getAuthHeaders());
    return res.data.users;
  } catch (error) {
    return rejectWithValue(error.response?.data?.message || 'Failed to fetch users');
  }
});

export const deleteUser = createAsyncThunk('adminUsers/deleteUser', async (id, { rejectWithValue }) => {
  try {
    await axios.delete(`http://localhost:5000/api/admin/users/${id}`, getAuthHeaders());
    return id;
  } catch (error) {
    return rejectWithValue(error.response?.data?.message || 'Failed to delete user');
  }
});

export const fetchSellers = createAsyncThunk('adminUsers/fetchSellers', async (_, { rejectWithValue }) => {
  try {
    const res = await axios.get('http://localhost:5000/api/admin/sellers', getAuthHeaders());
    return res.data.sellers;
  } catch (error) {
    return rejectWithValue(error.response?.data?.message || 'Failed to fetch sellers');
  }
});

export const approveSeller = createAsyncThunk('adminUsers/approveSeller', async (id, { rejectWithValue }) => {
  try {
    const res = await axios.put(`http://localhost:5000/api/admin/sellers/${id}/approve`, {}, getAuthHeaders());
    return { id, seller: res.data.user };
  } catch (error) {
    return rejectWithValue(error.response?.data?.message || 'Failed to approve seller');
  }
});

export const rejectSeller = createAsyncThunk('adminUsers/rejectSeller', async ({ id, reason }, { rejectWithValue }) => {
  try {
    const res = await axios.put(`http://localhost:5000/api/admin/sellers/${id}/reject`, { reason }, getAuthHeaders());
    return { id, seller: res.data.user };
  } catch (error) {
    return rejectWithValue(error.response?.data?.message || 'Failed to reject seller');
  }
});

const adminUsersSlice = createSlice({
  name: 'adminUsers',
  initialState: {
    users: [],
    sellers: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    // Users
    builder.addCase(fetchUsers.pending, (state) => { state.loading = true; state.error = null; })
      .addCase(fetchUsers.fulfilled, (state, action) => { state.loading = false; state.users = action.payload; })
      .addCase(fetchUsers.rejected, (state, action) => { state.loading = false; state.error = action.payload; })
      .addCase(deleteUser.fulfilled, (state, action) => {
        state.users = state.users.filter(u => u._id !== action.payload);
      });

    // Sellers
    builder.addCase(fetchSellers.pending, (state) => { state.loading = true; state.error = null; })
      .addCase(fetchSellers.fulfilled, (state, action) => { state.loading = false; state.sellers = action.payload; })
      .addCase(fetchSellers.rejected, (state, action) => { state.loading = false; state.error = action.payload; })
      .addCase(approveSeller.fulfilled, (state, action) => {
        const idx = state.sellers.findIndex(s => s._id === action.payload.id);
        if (idx !== -1) {
          state.sellers[idx].sellerStatus = 'approved';
        }
      })
      .addCase(rejectSeller.fulfilled, (state, action) => {
        const idx = state.sellers.findIndex(s => s._id === action.payload.id);
        if (idx !== -1) {
          state.sellers[idx].sellerStatus = 'rejected';
        }
      });
  }
});

export default adminUsersSlice.reducer;
